import Vue from 'vue';
import Router from 'vue-router';
import routes from './router'
// import $fn from '@/utils/fn';
// import PageApi from '@/apis/pageApi'
import cookies from "@/utils/cookie";
import user from "@/store/module/user"
import discover from "@/store/module/discover"

import {
    getUserInfo,
} from '@/req/user'
const originalPush: any = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// 初始化下拉列表
const initDetailList = () => {
    // window.App.$store.dispatch('user/getPlatform')
    // window.App.$store.dispatch('user/getGame')
    // window.App.$store.dispatch('user/getGametype')
    // window.App.$store.dispatch('user/getServerlist')
    // window.App.$store.dispatch('user/getSpacetype')
    window.App.$store.dispatch('discover/getFeaturelist')
    // debugger;
}

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.publicPath,
    routes,
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
    // 权限控制
    if (to.meta && to.meta.auth && to.meta.auth.length > 0) {
        // tslint:disable-next-line:prefer-const
        for (let auth of to.meta.auth) {
            // 登录权限校验\
            if (auth === 1) {
                try {
                    if (discover.state.featurelist.length == 0) {
                        // initDetailList();
                        // debugger;
                    }
                    // if (!cookies.getToken()) {
                    //     next("/login")
                    // }
                    if (cookies.getToken()) {
                        const obj = {
                            token: cookies.getToken()
                        }
                        const res = await getUserInfo(obj)
                        if (res.code == 200) {
                            await window.App.$store.dispatch('user/authInfo', res.data.userinfo)
                            user.state.message = res.is_message;
                        }
                    }
                    // }
                    // if (!user.state.info) {
                    // const obj = {
                    //     token: cookies.getToken()
                    // }
                    // const res = await getUserInfo(obj)
                    // if (res.code == 200) {
                    //     await window.App.$store.dispatch('user/authInfo', res.data.userinfo)
                    // }
                    //        else { window.App.$Message.error(res.msg)
                    //         next("/login")
                    //     }
                    // }
                } catch (err) {
                    // return next("/login")
                }
            }
        }
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
    /* must call `next` */
})

export default router;
